export const preferredTimes = [
  { id: 'morning', value: 'morning', label: 'Morning' },
  { id: 'afternoon', value: 'afternoon', label: 'Afternoon' },
  { id: 'evening', value: 'evening', label: 'Evening' },
  { id: 'night', value: 'night', label: 'Night' },
]; 